import {
  UPLOAD_ROUTE_FILE,
  RECEIVE_TRACE_ROUTE_RESULTS,
  RECEIVE_ANALYZE_ROUTE_RESULTS,
  CLEAR_ANALYZE_RESULTS,
  TOGGLE_GPS_TRACE,
} from 'actions/types'

const initialState = {
  parsedData: null,
  traceRouteResult: null,
  analyzeResults: [],
  successful: false,
  showGPSTrace: true,
}

export const analyze = (state = initialState, action) => {
  switch (action.type) {
    case UPLOAD_ROUTE_FILE:
      return {
        ...state,
        parsedData: action.payload,
        traceRouteResult: null,
        analyzeResults: [],
        successful: false,
      }

    case RECEIVE_TRACE_ROUTE_RESULTS:
      return {
        ...state,
        traceRouteResult: action.payload,
        successful: true,
      }

    case RECEIVE_ANALYZE_ROUTE_RESULTS: {
      // Sort results by score (for autodp/truckdp) or time (for auto/truck)
      const sortedResults = action.payload
        .filter((result) => result.data && result.data.trip)
        .map((result) => {
          const trip = result.data.trip
          const summary = trip.summary || {}
          const summary_dp = trip.summary_dp || {}

          let sortValue = 0
          if (result.profile === 'autodp' || result.profile === 'truckdp') {
            // Sort by combined score (lower is better)
            sortValue =
              summary_dp.combined_score || summary_dp.score || Infinity
          } else {
            // Sort by time (lower is better)
            sortValue = summary.time || Infinity
          }

          return {
            ...result,
            sortValue,
          }
        })
        .sort((resultA, resultB) => resultA.sortValue - resultB.sortValue)

      return {
        ...state,
        analyzeResults: sortedResults,
        successful: true,
      }
    }

    case CLEAR_ANALYZE_RESULTS:
      return {
        ...state,
        traceRouteResult: null,
        analyzeResults: [],
        successful: false,
      }

    case TOGGLE_GPS_TRACE:
      return {
        ...state,
        showGPSTrace: action.payload,
      }

    default:
      return state
  }
}
